export default (sourceObject) =>
  typeof sourceObject === 'object' && sourceObject !== null
    ? Object.keys(sourceObject).reduce((accumulator, keyName) => {
        const value = sourceObject[keyName];
        accumulator[keyName] =
          value === 'true' ? true : value === 'false' ? false : value;
        return accumulator;
      }, {})
    : sourceObject;
